import { useState, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';

export const useAuth = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Memoizar verificação de autenticação
  const isAuthenticated = useMemo(() => {
    return !!localStorage.getItem('token') && !!localStorage.getItem('user');
  }, []);

  // Memoizar usuário atual
  const currentUser = useMemo(() => {
    try {
      const user = localStorage.getItem('user');
      return user ? JSON.parse(user) : null;
    } catch {
      return null;
    }
  }, []);

  // Memoizar hotel selecionado
  const selectedHotel = useMemo(() => {
    try {
      const hotel = localStorage.getItem('selectedHotel');
      return hotel ? JSON.parse(hotel) : null;
    } catch {
      return null;
    }
  }, []);

  const login = useCallback(async (credentials) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await authService.login(credentials);
      
      // Armazenar dados de forma segura
      localStorage.setItem('token', response.token);
      localStorage.setItem('user', JSON.stringify(response.user));

      // Verificar hotéis disponíveis
      const availableHotels = response.availableHotels || [];
      
      if (availableHotels.length === 0) {
        throw new Error('Usuário não tem acesso a nenhum hotel');
      }

      if (availableHotels.length === 1) {
        // Hotel único - seleção automática
        authService.setSelectedHotel(availableHotels[0]);
        navigate('/dashboard', { replace: true });
      } else {
        // Múltiplos hotéis - redirecionar para seleção
        navigate('/select-hotel', { replace: true });
      }

      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Erro interno do servidor';
      setError(errorMessage);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [navigate]);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('selectedHotel');
    navigate('/login', { replace: true });
  }, [navigate]);

  const setHotel = useCallback((hotel) => {
    authService.setSelectedHotel(hotel);
  }, []);

  return {
    isAuthenticated,
    currentUser,
    selectedHotel,
    isLoading,
    error,
    login,
    logout,
    setHotel
  };
};
